import { useEffect, useState, type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import { getNotaria } from '@/services/maestros.service';

import { type FormValues } from '@/interfaces/model/don.interface';
import { type INotaria } from '@/interfaces/model/TramiteNuevo/INotaria.interface';

import NotarioSeleccionado from './NotarioSeleccionado';
import SeleccionDeNotario from './SeleccionDeNotario';

const IndexStep3 = (): ReactElement => {
	const [selectedNotary, setSelectedNotary] = useState<INotaria | undefined>();
	const [selectOther, setSelectOther] = useState<boolean>(false);
	const { setValue, getValues } = useFormContext<FormValues>();
	
	useEffect(() => {
		const notarioSeleccionado = getValues('notarioSeleccionado');

		if (!selectedNotary) {
			const idNotaria = notarioSeleccionado?.split(';')?.[0] ?? '';
			getNotaria(idNotaria).then((res) => {
				if (res.data) {
					setSelectedNotary(res.data);
					setSelectOther(true);
					setValue('selectedNotary', res.data, { shouldDirty: false });
				}
			});
		}
		if (selectedNotary && notarioSeleccionado !== selectedNotary.codigoNotarioNotaria) {
			setSelectOther(true);
			setValue('notarioSeleccionado', selectedNotary.codigoNotarioNotaria,  { shouldDirty: true });
		}
	}, [selectedNotary, getValues('notarioSeleccionado')]);


	if (selectOther) {
		return (
			<NotarioSeleccionado 
				selectedNotary={selectedNotary as INotaria} 
				setSelectOther={setSelectOther}
			/>
		);
	}

	return (
		<SeleccionDeNotario setSelectedNotary={(notary) => {
			setSelectedNotary(notary);
			if (notary) {
				setValue('selectedNotary', notary, { shouldDirty: false });
			}
		}} />
	);
	
};

export default IndexStep3;
